import { Link } from 'react-router-dom';
import { PageHead, Photo, photos } from './Editorial.jsx';

// The public home, resident, supplier and home services pages now live in site/. This file keeps the
// signed-out view of the housing provider workspace, which belongs to the app.

const BEDMAPS_URL = 'https://bedmaps.com';

/** What signed-out visitors see at /housing-provider/repairs. */
export function HousingTeamsExplainer() {
  return <div className="rs-container rs-page">
    <PageHead kicker="FOR HOUSING TEAMS" title="Connected housing support" lede="BedMaps providers automatically have an integrated resident portal for their tenants to report issues."/>
    <section className="rs-split is-even">
      <Photo photo={photos.housingTeams} className="rs-split-photo is-square" eager/>
      <div className="rs-explain-column">
        <ol className="rs-explain-list">
          <li><h2 className="rs-h3">Residents report an issue</h2><p>Tenants use their resident portal to tell their housing team what needs attention.</p></li>
          <li><h2 className="rs-h3">Your housing team receives it</h2><p>For BedMaps providers, the report goes into the connected housing system.</p></li>
          <li><h2 className="rs-h3">Manage the repair in BedMaps</h2><p>The housing team manages the issue from its housing system.</p></li>
        </ol>
        <a className="rs-button is-large" href={BEDMAPS_URL} target="_blank" rel="noreferrer">Learn about BedMaps<span className="visually-hidden"> (opens in a new tab)</span></a>
        <Link className="rs-button is-large" to="/repairs">Open resident portal</Link>
      </div>
    </section>
  </div>;
}
